(function () {
  const initFbPdp = (root) => {
    if (!root || root.dataset.fbPdpInit === 'true') return;

    const variantsEl = root.querySelector('[data-fb-variants]');
    const variantMediaEl = root.querySelector('[data-fb-variant-media]');
    const colorMediaEl = root.querySelector('[data-fb-color-media]');
    const variantInput = root.querySelector('[data-fb-variant-id]');
    const priceEl = root.querySelector('[data-fb-pdp-price]');
    const compareEl = root.querySelector('[data-fb-pdp-compare]');
    const submitBtn = root.querySelector('[data-fb-pdp-submit]');
    const shopNowBtn = root.querySelector('[data-fb-shop-now]');
    const qtyInput = root.querySelector('[data-fb-qty-input]');
    const qtyMinus = root.querySelector('[data-fb-qty-minus]');
    const qtyPlus = root.querySelector('[data-fb-qty-plus]');
    const mainImg = root.querySelector('.fb-pdp__main-img, #fb-pdp-main-img, .fb-pdp__main-media img');
    const gallery = root.querySelector('[data-fb-pdp-gallery]');
    const form = root.querySelector('[data-fb-pdp-form]');
    const moneyFormatEl = root.querySelector('[data-fb-money-format]');
    let moneyFormat = '${{amount}}';

    if (moneyFormatEl) {
      try {
        moneyFormat = JSON.parse(moneyFormatEl.textContent);
      } catch (e) {
        moneyFormat = moneyFormatEl.textContent.trim() || moneyFormat;
      }
    }

    if (!variantsEl || !variantInput) return;

    let variants = [];
    let variantMedia = {};
    let colorMedia = {};

    try {
      variants = JSON.parse(variantsEl.textContent);
    } catch (e) {
      return;
    }

    if (variantMediaEl) {
      try {
        variantMedia = JSON.parse(variantMediaEl.textContent);
      } catch (e) {
        variantMedia = {};
      }
    }

    if (colorMediaEl) {
      try {
        colorMedia = JSON.parse(colorMediaEl.textContent);
      } catch (e) {
        colorMedia = {};
      }
    }

    root.dataset.fbPdpInit = 'true';

    const formatMoney = (cents) => {
      const amount = (cents / 100).toFixed(2);
      if (moneyFormat.includes('{{amount}}')) return moneyFormat.replace('{{amount}}', amount);
      if (moneyFormat.includes('{{amount_no_decimals}}')) {
        return moneyFormat.replace('{{amount_no_decimals}}', String(Math.round(cents / 100)));
      }
      return `$${amount}`;
    };

    const getSelectedOptions = () => {
      const options = [];
      root.querySelectorAll('[data-fb-option]').forEach((input) => {
        if (input.checked) options[parseInt(input.dataset.fbOption, 10) - 1] = input.value;
      });
      return options;
    };

    const findVariant = () => {
      const selected = getSelectedOptions();
      return variants.find((variant) => variant.options.every((opt, i) => opt === selected[i]));
    };

    const normalizeImageSrc = (src) => {
      if (!src) return '';
      const absolute = src.startsWith('//') ? `https:${src}` : src;
      if (absolute.includes('width=')) return absolute;
      return `${absolute}${absolute.includes('?') ? '&' : '?'}width=1400`;
    };

    const setMainImage = (src, mediaId) => {
      if (!src || !mainImg) return;
      const normalized = normalizeImageSrc(src);
      mainImg.src = normalized;
      mainImg.removeAttribute('srcset');
      mainImg.removeAttribute('sizes');
      if (mediaId == null) return;
      const mediaKey = String(mediaId);
      root.querySelectorAll('[data-fb-pdp-thumb]').forEach((thumb) => {
        const active = thumb.dataset.mediaId === mediaKey;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    };

    const getVariantImage = (variant) => {
      const mapped = variantMedia[String(variant.id)];
      if (mapped && mapped.src) return mapped;

      const selected = getSelectedOptions();
      for (const color of selected) {
        if (color && colorMedia[color] && colorMedia[color].src) return colorMedia[color];
      }

      if (variant.featured_image && variant.featured_image.src) {
        return { src: variant.featured_image.src, mediaId: variant.featured_image.id || null };
      }

      return null;
    };

    const getColorOptionPosition = () => {
      const fieldsets = root.querySelectorAll('.fb-pdp__option');
      for (const fieldset of fieldsets) {
        const legend = fieldset.querySelector('.fb-pdp__option-label');
        if (!legend) continue;
        const name = legend.textContent.trim().toLowerCase();
        if (name === 'color' || name === 'colour' || name === '颜色') {
          const input = fieldset.querySelector('[data-fb-option]');
          if (input) return parseInt(input.dataset.fbOption, 10);
        }
      }
      return null;
    };

    const colorOptionPosition = getColorOptionPosition();

    const updateVariantUI = (updateImage = true) => {
      const variant = findVariant();
      if (!variant) {
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Unavailable';
        }
        return;
      }

      variantInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        submitBtn.textContent = variant.available
          ? (root.dataset.addLabel || 'Add to Cart')
          : (root.dataset.soldLabel || 'Sold Out');
      }
      if (shopNowBtn) {
        shopNowBtn.disabled = !variant.available;
      }

      const image = getVariantImage(variant);
      if (updateImage && image) setMainImage(image.src, image.mediaId);

      root.querySelectorAll('.fb-pdp__option-value').forEach((label) => {
        const input = label.querySelector('input');
        label.classList.toggle('is-selected', Boolean(input && input.checked));
      });
    };

    const handleThumb = (thumb) => {
      if (!thumb) return;
      setMainImage(thumb.dataset.src, thumb.dataset.mediaId);
    };

    const handleOption = (input) => {
      if (!input || input.checked) return;
      root.querySelectorAll(`[data-fb-option="${input.dataset.fbOption}"]`).forEach((el) => {
        el.checked = el === input;
      });
      const isColorChange = colorOptionPosition != null
        && parseInt(input.dataset.fbOption, 10) === colorOptionPosition;
      updateVariantUI(isColorChange);
    };

    if (form) {
      form.addEventListener('change', (event) => {
        if (!event.target.matches('[data-fb-option]')) return;
        const isColorChange = colorOptionPosition != null
          && parseInt(event.target.dataset.fbOption, 10) === colorOptionPosition;
        updateVariantUI(isColorChange);
      });
    }

    const clampQty = (value) => Math.max(1, parseInt(value, 10) || 1);

    if (qtyInput) {
      qtyInput.addEventListener('change', () => {
        qtyInput.value = String(clampQty(qtyInput.value));
      });
    }

    qtyMinus?.addEventListener('click', () => {
      if (!qtyInput) return;
      qtyInput.value = String(clampQty(parseInt(qtyInput.value, 10) - 1));
    });

    qtyPlus?.addEventListener('click', () => {
      if (!qtyInput) return;
      qtyInput.value = String(clampQty(parseInt(qtyInput.value, 10) + 1));
    });

    shopNowBtn?.addEventListener('click', async () => {
      if (!form || shopNowBtn.disabled) return;
      const variant = findVariant();
      if (!variant || !variant.available) return;

      const quantity = qtyInput ? clampQty(qtyInput.value) : 1;
      shopNowBtn.disabled = true;
      const originalText = shopNowBtn.textContent;
      shopNowBtn.textContent = 'Processing...';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            items: [{ id: variant.id, quantity }],
          }),
        });

        if (!response.ok) throw new Error('Add to cart failed');

        window.location.href = '/checkout';
      } catch (error) {
        shopNowBtn.disabled = false;
        shopNowBtn.textContent = originalText;
      }
    });

    if (gallery) {
      gallery.addEventListener('click', (event) => {
        const thumb = event.target.closest('[data-fb-pdp-thumb]');
        if (!thumb) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        handleThumb(thumb);
      }, true);
    }

    root.addEventListener('click', (event) => {
      const thumb = event.target.closest('[data-fb-pdp-thumb]');
      if (thumb) {
        event.preventDefault();
        event.stopImmediatePropagation();
        handleThumb(thumb);
        return;
      }

      const label = event.target.closest('.fb-pdp__option-value');
      if (label) {
        const input = label.querySelector('[data-fb-option]');
        if (input) {
          event.preventDefault();
          event.stopImmediatePropagation();
          handleOption(input);
        }
      }
    }, true);

    // Keep first gallery image on load; only sync image when color changes or thumb is clicked.
    updateVariantUI(false);
  };

  const boot = (container) => {
    (container || document).querySelectorAll('[data-fb-pdp]').forEach((root) => {
      delete root.dataset.fbPdpInit;
      initFbPdp(root);
    });
  };

  window.initFbPdp = initFbPdp;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    boot(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-fb-pdp]').forEach((root) => {
      delete root.dataset.fbPdpInit;
    });
  });
})();
